import { render } from "./MSFS.vue?vue&type=template&id=55a0e317&scoped=true&ts=true"
import script from "./MSFS.vue?vue&type=script&lang=ts"
export * from "./MSFS.vue?vue&type=script&lang=ts"

import "./MSFS.vue?vue&type=style&index=0&id=55a0e317&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a0e317"]])

export default __exports__